import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import {
  BadgeComponent,
  BadgeVariant,
  CardAccent,
  CardComponent,
  IconComponent,
  LoadingSkeletonComponent,
  ToolTipDirective,
  TranslatePipe,
} from '@softline/ui-core';

export interface DeliveryNoteRosterCardBadge {
  icon: string;
  label: string | null;
}

export interface DeliveryNoteRosterDetailInfo {
  label: string;
  detail: string;
  icon?: string;
}

const PURCHASE_ORDER_ACCENT = '#0176D3';

@Component({
  selector: 'soft-delivery-note-roster-card',
  imports: [
    CardComponent,
    BadgeComponent,
    IconComponent,
    LoadingSkeletonComponent,
    TranslatePipe,
    ToolTipDirective,
  ],
  templateUrl: './delivery-note-roster-card.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeliveryNoteRosterCardComponent {
  readonly title = input.required<string>();
  readonly subtitle = input<string>();
  readonly badges = input<DeliveryNoteRosterCardBadge[]>([]);
  readonly status = input<string | null>(null);
  readonly type = input<'A' | 'B' | null>(null);
  readonly locked = input<boolean>(false);
  readonly deleted = input<boolean>(false);
  readonly selected = input<boolean>(false);
  readonly tour = input<string>();
  readonly details = input<DeliveryNoteRosterDetailInfo[] | null>(null);
  readonly modeLetter = input<string | null>(null);
  readonly modeVariant = input<BadgeVariant>('secondary');
  readonly clampSubtitle = input<boolean>(true);
  readonly loading = input<boolean>(false);

  readonly accentColor = computed(() =>
    this.type() === 'B' ? PURCHASE_ORDER_ACCENT : ''
  );

  readonly statusColor = computed<CardAccent>(() => {
    const status = this.status();
    if (status === null) return 'primary';
    switch (status) {
      case '0':
        return 'danger';
      case '1000':
        return 'success';
      default:
        return 'warning';
    }
  });
}
